export const HelpItems = [
    {
        "id": 0,
        "title": "Is your ELD FMCSA certified?",
        "text": "In compliance with the FMCSA’s ELD Mandate, our ELD Compliance Solution was registered and certified by the FMCSA.",
        "status": false
    },
    {
        "id": 1,
        "title": "Do I have to print my logs during an inspection?",
        "text": `With our ELD, you’re not required to present physical logs. Our ELD is able to transfer data electronically, but screen displays can also be presented if need be. However, an enforcement officer may request that additional information be provided by email, fax, or other similar means within 48 hours of the roadside inspection.`,
        "status": false
    },
    {
        "id": 2,
        "title": "Will your ELD help prevent HOS violations?",
        "text": `Blue Star ELD is designed to notify drivers, safety officials of potential violations beforehand. Notifications will be received by the aforementioned parties 1 hour, 30 minutes, 15 minutes, and 5 minutes prior to the violation.`,
        "status": false
    },
    {
        "id": 3,
        "title": "Will the application work on my cell phone?",
        "text": `While ELD devices will connect and work with cellular phones, we highly recommend running our application on a tablet for optimal performance.`,
        "status": false
    },
    {
        "id": 4,
        "title": "How ELD Device installed in the truck?",
        "text": `Blue Star ELD can be installed effortlessly. Once you plug the ELD device into the diagnostics port of your vehicle, On the app you need to input the ELD Device MAC Address and, you device should be paired`,
        "status": false
    },
    {
        "id": 5,
        "title": "How can drivers create driver vehicle inspection reports",
        "text": "Drivers can use the BLue Star ELD Electronic Logbook App to create DVIRs. The DVIRs created in the app can be accessed by fleet managers by viewing the Blue Star ELD Portal (Dashboard).",
        "status": false
    },
    {
        "id": 6,
        "title": "Will the Blue Star ELD be compatible with my truck?",
        "text": `Most likely, yes. You can make sure of this when you order your electronic logging device. The Blue Star ELD can be plugged into all standard 6-pin, 9-pin or OBDII diagnostic ports. For Mack or Volvo trucks made after 2013, Blue Star ELD can provide special cable harnesses. For added safety, Blue Star ELD also provides you with Y-cables to hide any cables behind the trim panel and out of the way of drivers’ legs.`,
        "status": false
    },
    {
        "id": 7,
        "title": "How much data does the BlueStarELD App use on a driver’s phone?",
        "text": `Data overages aren’t a problem for users of Blue Star ELD, as they typically use about 100 MB of data a month, making them an affordable option. Most cellular plans allow for 1-10 GB of data a month. That’s X times more data than the ELD uses.`,
        "status": false
    },
    {
        "id": 8,
        "title": "Is cellular data needed in order to use the Blue Star ELD or App?",
        "text": `No. Drivers can use both the Blue Star ELD and Electronic Logbook App while offline. If they need to back up data or share logs with their employer, however, they will need to connect to Wi-Fi. In order to avoid relying on public Wi-Fi or hotspots, Blue Star ELD recommends having a cellular data plan to rely upon for regular usage.`,
        "status": false
    },
    {
        "id": 5,
        "title": "How is driving time recorded?",
        "text": "A driver’s driving time will be automatically recorded as long as the driver connects their mobile device to the ELD via Bluetooth and the vehicle is registered in the Blue Star ELD App. A vehicle is considered to be in motion if it is traveling over 5 mph.",
        "status": false
    }
]